import React from 'react'
import '../styles/BioStyle.css'
import HideText from '../reusable/HideText'

function WatashiBio() {
  return (
    <div id='BioDiv'>
        <div id='BioTextDiv'>
            <h2 id='bioTitle'>this is me</h2>
            <div id='bioText'>
            <p>i am <HideText originalText={"XXX"} />.
            i am a cs student based in <HideText originalText={"XXXXXX"}/> <br /><br />
            my aim with this site is to keep track of my projects and hobbies. it was also created to help me get started with learning web development.<br /><br />
            but other than that, i really dont know in what direction this site is going to go. <br /><br />
            you can check out the projects page, to see what i am working on rn if you are interested.<br /><br />
            the only way to get an account is, if i make you one. no registrations.<br /><br />
            </p>
            <p id='lastWords'>"pre-occupied by one leaf, you'll miss the whole tree. pre-occupied with a single tree, you'll miss the entire forest"</p>
            </div>
        </div>
        <div id='BioImageDiv'>
    <img src='./images/vagabond_invert.jpg' alt='vagabond' id='vagabondImg'></img>
        </div>
    </div>
  )
}

export default WatashiBio